import React, { useState } from 'react'
import AOS from "aos"; // Import AOS library

import CustomHelmet from '../components/CustomHelmet'
import Banner from '../components/Banner'
import { t } from 'i18next'
import * as constants from "../constants";
import { fetchAPI } from '../helper/fetchAPI';
import { useTranslation } from 'react-i18next';
import FullScreenLoader from '../components/FullScreenLoader';
import { useCountryPrefix } from '../routes/useCountryPrefix';
import PartnerSec from '../sections/partner/PartnerSec';
import ContactUsForm from '../components/ContactUsForm';

const Partner = () => {

    const { i18n } = useTranslation();
    const countryPrefix = useCountryPrefix();

    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";
    const [pageContent, setPageContent] = useState();
    const [isLoaded, setIsLoaded] = useState(false);

    let apiUrl = process.env.REACT_APP_API_URL;

    apiUrl = `${apiUrl}${constants.cmsfranchise}?language=${language}&region_id=${countryPrefix}`;

    const fetchData = async () => {
        const res = await fetchAPI(apiUrl, "Get");
        if (res?.status === 200) {
            debugger
            setPageContent(res?.data)
            setIsLoaded(true)

        }
    }


    React.useEffect(() => {
        AOS.init();
        fetchData()
    }, []);

    if (!isLoaded) {
        return (
            <FullScreenLoader style={{ minHeight: '100vh' }} />
        )
    }
    return (
        <>

            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />
            <Banner
                title={pageContent?.title}
                desc={pageContent?.description}
                cssClass={"career-intro-text"}
                imageUrl={pageContent?.bannerImage}
            ></Banner>
            <PartnerSec data={pageContent} />
            <ContactUsForm imgDiv={false} />

        </>
    )
}

export default Partner